import { batchActions } from './utils';
import { setData } from './data';
import { setStatus, unsetStatus } from './status';
import { LOADING, ERROR, selectCountriesStatus, selectCountries } from './selectors';
import { COUNTRIES_KEY } from '../lib/constants';
import { toJSON, PODCASTERS_SERVICE } from '../lib/Request';
import { Thunk, Country } from '../types';

const INITIAL_COUNTRY_STATE = {
  name: '',
  code: '',
};

export const loadCountries = (): Thunk => async (dispatch, getState, { request }) => {
  const KEY = 'countries';
  const endpoint = `${PODCASTERS_SERVICE}/v0/feeds/countries`;

  /* istanbul ignore next */
  if (selectCountriesStatus(getState()) === LOADING) return;

  dispatch(setStatus({ [KEY]: LOADING }, 'submission/LOAD_COUNTRIES_REQUEST'));

  try {
    const data: Country[] = await request.get(endpoint).then(toJSON);

    dispatch(
      batchActions(
        [setData({ [KEY]: data }), unsetStatus([KEY])],
        'submission/LOAD_COUNTRIES_SUCCESS',
      ),
    );
  } catch (err) {
    switch (err.name) {
      case 'ResponseError':
      case 'TokenError': {
        dispatch(setStatus({ [KEY]: ERROR }, 'submission/LOAD_COUNTRIES_ERROR'));
        break;
      }

      /* istanbul ignore next */
      default:
        throw err;
    }
  }
};

export const initializeCountry = (): Thunk => dispatch => {
  dispatch(setData({ [COUNTRIES_KEY]: INITIAL_COUNTRY_STATE }, 'submission/INITIALIZE_COUNTRY'));
};

export const setCountry = (country: Country): Thunk => dispatch => {
  dispatch(setData({ [COUNTRIES_KEY]: country }, 'submission/SET_COUNTRY'));
};
